<template>
  <div v-if="user" class="banner-right">
    <div class="banner-right__user">
      <span class="banner-right__user--link">{{user.name}}</span>
      <button class="banner-right__user--icon" @click="signout">
        <font-awesome-icon icon="chevron-down" />
      </button>
    </div>
    <transition name="fade">
      <ul class="banner-right__dropdown" v-show="isVisible">
        <li class="banner-right__list-item" @click="signout">Logout</li>
      </ul>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "banner-right",

  data() {
    return {
      isVisible: false
    };
  },

  methods: {
    ...mapActions("auth", ["signout"]),

    onClick() {
      this.isVisible = !this.isVisible;
    }
  },

  computed: {
    ...mapState({
      auth: state => state.auth
    }),

    user() {
      return this.auth.user;
    }
  }
};
</script>

<style lang="sass" scoped>
.banner-right
  position: relative
  z-index: 10

  &__user
    display: flex
    align-items: center
    height: 40px
    color: $c-white
    
    &--link
      display: flex
      align-items: center
      height: 40px
      transition: color .3s ease-in-out

      &:hover
        pointer: cursor
        text-decoration: underline
        color: $c-white

    &--icon
      margin-left: 10px
      outline: none

  &__dropdown
    font:
      size: 13px
      weight: normal
    background: $c-white
    box-shadow: -2px 2px 5px 0 rgba(0, 0, 0, .75)

    &__list-item
      padding: 10px
      cursor: pointer

  .fade-enter-active, .fade-leave-active
    transition: opacity .3s

  .fade-enter, .fade-leave-to
    opacity: 0

</style>